/**
 * Configuration des types de clients
 */
export const CLIENT_TYPE_CONFIG = {
  client: { label: 'Client', color: '#28a745', bgColor: '#d4edda' },
  partenaire: { label: 'Partenaire', color: '#17a2b8', bgColor: '#d1ecf1' },
  agence_interim: { label: 'Agence interim', color: '#6f42c1', bgColor: '#e2d9f3' },
  non_qualifie: { label: 'Non qualifie', color: '#856404', bgColor: '#fff3cd' }
};

/**
 * Helper pour obtenir la config d'un type de client
 */
export const getClientTypeDisplay = (clientType) => {
  const type = clientType || 'non_qualifie';
  return CLIENT_TYPE_CONFIG[type] || CLIENT_TYPE_CONFIG.non_qualifie;
};
